<template lang="pug">
.registration-questions
  .registration-questions__inner
    h2.registration-questions__heading {{copy.heading}}
      small(@click="updateQuestions('test', 1)") Optional
    form.registration-questions__form(v-on:submit.prevent="processOptionalQuestions" :name="optionalQuestionsData.formName")
      fieldset.registration-questions__fieldset(v-for="(val,index) in optionalQuestionsData.questions")
        legend.registration-questions__legend {{val.text}}
        template(v-for="(radio) in val.choices")
          .registration-questions__inline.registration-questions__inline--radio
            //- input.registration-questions__input.registration-questions__input--radio(type="radio", :name="val.field" :id="radio.value" :value="`${val.field}|${radio.value}`" v-model="formData[index]")
            input.registration-questions__input.registration-questions__input--radio(type="radio", :name="val.field" :id="radio.value" :value="`${val.field}|${radio.value}`" :disabled="isDisabled" :checked="radio.selected" @change="updateQuestions(`${val.field}|${radio.value}`, index)")
            label.registration-questions__label(:for="radio.value") {{radio.text}}
      button.registration-questions__button.registration-questions__button--alt(@click.prevent="skipOptionalQuestions" :disabled="isDisabled") {{copy.skip}}
      input.registration-questions__button(type="submit" value="Submit" :disabled="isDisabled")
</template>

<script>
import optionalQuestionsCopy from "../../../../data/registrationOptionalQuestions.json"
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "PageOptionalQuestions",
  data() {
    return{
      copy: optionalQuestionsCopy.registrationOptionalQuestions.default,
      getQuestionsEndpoint: '/api/account/getoptionalquestions',
      setQuestionsEndpoint: '/api/account/saveoptionalquestions',
      optionalQuestionsData: {
      },
      optionalQuestionsCount: '',
      formData: null
    }
  },
  computed: {
		...mapGetters(["isError", "isDisabled", "isLoading"])
  },
  methods: {
		...mapMutations(["setRegistration","setOptionalQuestions", "setDisabled", "setLoading"]),
		...mapActions(["getData","submitOptionalQuestions"]),
    processOptionalQuestions(data) {
      data.preventDefault()
      // console.log(data)
      // split form element values by | to prevent writing complicated dynamic computed getters.
      // object -> array -> map -> split -> loop -> create object -> push to array
      let formData = []
      formData.push({
        "name": data.target.name
      })
      Object.values(this.formData).map(x => x.split('|')).forEach(element => {
          formData.push({
            "field" : element[0],
            "choice" : element[1]
          })
      });
      // console.log(formData)
      const endpoint = this.setQuestionsEndpoint
      // formData.endpoint = this.setQuestionsEndpoint
      // console.log(formData)
      // do stuff
      this.setDisabled(true)
      this.setLoading(true)
      this.submitOptionalQuestions({formData, endpoint})
    },
    skipOptionalQuestions() {
      this.setOptionalQuestions(false)
    },
    updateQuestions(val, index) {
      this.formData[index] = val
    }
  },
  created() {
    this.setLoading(true)
    fetch(this.getQuestionsEndpoint, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }).then((response) => response.json())
      .then((data) => {
        this.optionalQuestionsData = Object.assign({},data)
        this.formData = new Array(data.questions.length)
        for (let i = 0; i < this.optionalQuestionsData.questions.length; i++) {
          const question = this.optionalQuestionsData.questions[i];
          // console.log(question)
          question.choices.forEach(choice => {
            if(choice.selected) {
              this.formData[i] = `${question.field}|${choice.value}`
            }
        });
        setTimeout(() => {
          this.setLoading(false)
        }, 1000);
      }
      });
  },
  // watch: {
  //   optionalQuestionsData(){
      
  //   },
  // }
};
</script>

<style lang="scss" scoped>
.registration-questions {
    background: var(--registration-blue);
    color: $white;
    font-family: var(--registration-font-family);
    padding: 33px 53px 33px 19px;
    &__inner {

    }
    &__heading {
        font-size: 2em;
        font-weight: 600;
        margin-bottom: var(--registration-gap-base);
        font-family: var(--registration-font-family-bold);
        small {
            display: block;
            font-family: 'Gilroy-Thin',Arial,Helvetica,sans-serif;
            font-size: .5em;
            font-style: italic;
            font-weight: 100;
        }
    }
    &__title {
        font-weight: 600;
        font-family: var(--registration-font-family);
        font-size: 1.35em;
        margin-bottom: calc(var(--registration-gap-base)*2);
    }
    &__form {
        display: flex;
        flex: 1 1 auto;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
    }
    &__fieldset {
        display: flex;
        flex-direction: column;
        flex: 1 1 100%;
        margin-bottom: var(--registration-gap-base);
    }
    &__legend {
        font-size: 1em;
        font-family: var(--registration-font-family-bold);
        margin-bottom: calc(var(--registration-gap-base)*.5);
    }
    &__inline {
      
      width: 100%;
      .registration-page__input {
        margin-right: calc(var(--registration-gap-base)*.5);
        align-self: center;
      }
      &--radio,
      &--checkbox {
        display: grid;
        grid-template-columns: 1em auto;
        gap: calc(var(--registration-gap-base) * .5);
        margin-top: 3px;
      }
      input[type="radio"],
      input[type="checkbox"] {
        appearance: none;
        /* For iOS < 15 to remove gradient background */
        background-color: none;
        font: inherit;
        color: currentColor;
        width: var(--registration-input-size);
        height: var(--registration-input-size);
        border: 0.15em solid #fff;
        border-radius: 50%;
        padding: 0;
        display: grid;
        place-content: center;
        &:before {
          content: "";
          width: 1em;
          height: 1.1em;
          border-radius: 50%;
          transform: scale(0);
          transition: 120ms transform ease-in-out;
          box-shadow: inset 1em 1em var(--registration-button-teal);
        }
        &:checked::before {
          transform: scale(.4);
        }
      }
      input[type="checkbox"] {
        border-radius: 0;
        &:before {
          content:'';
          font-family: "Font Awesome 5 Pro";
          font-size: 1.5em;
          color: var(--registration-button-teal);
          border-radius: 0;
          box-shadow: none;
          transform: translate(calc(-1 *(var(--registration-input-size)*.25)),calc(-1 * (var(--registration-input-size)*.25)))
        }
        &:checked:before {
          content: '\f00c';
          transform: scale(1.5) translate(calc((var(--registration-input-size)*.25)),calc(-1 * (var(--registration-input-size)*.35)));
        }
      }
    }
    &__label {
        margin-right: calc(var(--registration-gap-base)*.5);
        text-transform: capitalize;
    }
    &__button {
        background-color: var(--registration-button-blue);
        border: none;
        color: $white;
        flex: 0 1 49%;
        padding: calc(var(--registration-gap-base)*.5) 0;
        &[type="submit"] {
          border-radius: 0;
        }
        &:hover{
            background-color: var(--registration-button-blue-hover)
        }
        &--alt {
            background-color: var(--registration-button-dark-teal);
            &:hover{
                background-color: var(--registration-button-dark-teal-hover)
            }
        }
    }
}
</style>
